module.exports = __webpack_public_path__ + "img/w3_rocket_dark.e1f0cb7e.png";